import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserRouterSelectors } from '@lockton-apps/shared/data-access/router';

import {
  CONTACTS_FEATURE_KEY,
  ContactsState,
  contactsAdapter,
} from './contacts.reducer';

// Lookup the 'Contacts' feature state managed by NgRx
export const getContactsState =
  createFeatureSelector<ContactsState>(CONTACTS_FEATURE_KEY);

const { selectAll, selectEntities } = contactsAdapter.getSelectors();

export const getContactsLoaded = createSelector(
  getContactsState,
  (state: ContactsState) => state.loaded
);

export const getMutationsLoadingState = createSelector(
  getContactsState,
  (state: ContactsState) => state.mutationsLoading
);

export const getContactsError = createSelector(
  getContactsState,
  (state: ContactsState) => state.error
);

export const getAllContacts = createSelector(
  getContactsState,
  (state: ContactsState) => selectAll(state)
);

export const getContactsEntities = createSelector(
  getContactsState,
  (state: ContactsState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getContactsState,
  (state: ContactsState) => state.selectedId
);

export const getSelected = createSelector(
  getContactsEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const getRouted = createSelector(
  getContactsEntities,
  UserRouterSelectors.selectRoutedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const getAllAndLoaded = createSelector(
  getContactsLoaded,
  getAllContacts,
  (contactsLoaded, allContacts) => ({
    contactsLoaded,
    allContacts,
  })
);
